import { useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Label,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell
} from "recharts";

export default function PieChartPro({ mapData, total }) {

  useEffect(() => {
    console.log(mapData);
  }, [mapData])

  const chartCountryAllocations = mapData || [];



  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

  const data01 = [
    { name: "Active Campagins", value: 90 },
    { name: "Inactive Campagins", value: 25 },
    { name: "ICPs with no campagins", value: 10 }
  ];

  const Bullet = ({ backgroundColor, size }) => {
    return (
      <div
        className="CirecleBullet"
        style={{
          backgroundColor,
          width: size,
          height: size
        }}
      ></div>
    );
  };
  
  const CustomizedLegend = (props) => {
    const { payload } = props;
    return (
      <ul className="LegendList">
        {payload.map((entry, index) => (
          <li key={`item-${index}`}>
            <div className="BulletLabel">
              <Bullet backgroundColor={entry.payload.fill} size="10px" />
              <div className="BulletLabelText">{entry.value} - {entry.payload.value.toLocaleString('en-IN')}</div>
            </div>
            {/* <div style={{ marginLeft: "20px" }}>{entry.payload.value}</div> */}
          </li>
        ))}
      </ul>
    );
  };
  
  const CustomLabel = ({ viewBox, labelText, value }) => {
    const { cx, cy } = viewBox;
    return (
      <g>
        <text
          x={cx}
          y={cy}
          className="recharts-text recharts-label"
          textAnchor="middle"
          dominantBaseline="central"
          alignmentBaseline="middle"
          fontSize="20"
        >
          {labelText}
        </text>
        <text
          x={cx}
          y={cy + 25}
          className="recharts-text recharts-label"
          textAnchor="middle"
          dominantBaseline="central"
          alignmentBaseline="middle"
          fill="#0088FE"
          fontSize="20"
          fontWeight="600"
        >
          {value}
        </text>
      </g>
    );
  };

  return (

    <div style={{ width: "100%", height: 400 }}>
      <ResponsiveContainer>


        <PieChart>
          <Pie
            data={mapData}
            dataKey="value"
            cx='50%'
            cy='50%'
            innerRadius={80}
            outerRadius={150}
          >
            {mapData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
            <Label
              content={<CustomLabel labelText="Total" value={total} />}
              position="center"              
            />
          </Pie>
          <Legend content={<CustomizedLegend />} />
        </PieChart>

      </ResponsiveContainer>
    </div>
  );
}